import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { PartInput, ForgingSequence, MachineId } from './engineeringRules';

export interface Job {
  id: string;
  created_at: string;
  updated_at: string;
  status: 'DRAFT' | 'PARSING' | 'REVIEW' | 'PLANNING' | 'APPROVED' | 'COMPLETE';
  customer: string;
  part_no: string;
  description: string;
  drawing_filename?: string;
  drawing_url?: string;
  part?: PartInput;
  parse_confidence?: number;
  parse_notes?: string[];
  selected_machine?: MachineId;
  sequence?: ForgingSequence;
  engineer_notes?: string;
  approved_by?: string;
  approved_at?: string;
}

interface AppStore {
  jobs: Job[];
  activeJobId: string | null;
  addJob: (job: Omit<Job, 'id' | 'created_at' | 'updated_at'>) => string;
  updateJob: (id: string, updates: Partial<Job>) => void;
  deleteJob: (id: string) => void;
  setActiveJob: (id: string | null) => void;
  getJob: (id: string) => Job | undefined;
}

export const useAppStore = create<AppStore>()(
  persist(
    (set, get) => ({
      jobs: [],
      activeJobId: null,
      addJob: (job) => {
        const id = `JOB-${Date.now()}`;
        const now = new Date().toISOString();
        set(s => ({ jobs: [{ ...job, id, created_at: now, updated_at: now }, ...s.jobs] }));
        return id;
      },
      updateJob: (id, updates) => set(s => ({
        jobs: s.jobs.map(j => j.id === id ? { ...j, ...updates, updated_at: new Date().toISOString() } : j)
      })),
      deleteJob: (id) => set(s => ({ jobs: s.jobs.filter(j => j.id !== id) })),
      setActiveJob: (id) => set({ activeJobId: id }),
      getJob: (id) => get().jobs.find(j => j.id === id),
    }),
    { name: 'forgeiq-store' }
  )
);
